module.exports = __webpack_public_path__ + "img/kegs.b39c9968.svg";